import styled, { css } from 'styled-components'

import theme, { rem } from '../../utils/theme'
import Tooltip from '../Tooltip'

export const StyledContainer = styled.div`
  background-color: ${theme.colors.white};
  border: 1px solid ${theme.colors.border};
  border-radius: ${rem(3)};
  color: ${theme.colors.slate};
  font-size: ${theme.typography.fontSizeMicro};
  line-height: 1;
  padding: ${rem(3)} ${rem(5)};
  text-align: center;
  text-transform: uppercase;

  ${props =>
    props.variant === 'new' &&
    css`
      background-color: ${theme.colors.blueNew};
      border: 1px solid ${theme.colors.blueNew};
      color: ${theme.colors.white};
    `}

  ${props =>
    props.variant === 'sale' &&
    css`
      background-color: ${theme.colors.red};
      border: 1px solid ${theme.colors.red};
      color: ${theme.colors.white};
    `}

  ${props =>
    props.variant === 'beta' &&
    css`
      background-color: ${theme.colors.white};
      border: 1px solid ${theme.colors.border};
      font-weight: ${theme.typography.fontWeightBold};
      color: ${theme.colors.darkestGrey};
    `}

  ${props =>
    props.variant === 'info' &&
    css`
      background-color: ${theme.colors.darkGrey};
      border: 1px solid ${theme.colors.darkGrey};
      color: ${theme.colors.white};
      text-transform: inherit;
      font-weight: ${theme.typography.fontWeightBolder};
      font-size: ${theme.typography.fontSizeTinyish};
    `}

  ${props =>
    props.variant === 'pending' &&
    css`
      background-color: ${theme.colors.blue};
      border: 1px solid ${theme.colors.blue};
      color: ${theme.colors.white};
      text-transform: inherit;
      font-weight: ${theme.typography.fontWeightBolder};
      font-size: ${theme.typography.fontSizeTinyish};
    `}
`

const FlagComponent = ({ variant = '', title, invert, showToolTip, toolTipText, style }) =>
  showToolTip && toolTipText ? (
    <Tooltip content={toolTipText} placement="bottom">
      {/* biome-ignore lint/complexity/useOptionalChain: TODO */}
      <StyledContainer variant={variant && variant.toLowerCase()} invert={invert} style={style}>
        {title}
      </StyledContainer>
    </Tooltip>
  ) : (
    // biome-ignore lint/complexity/useOptionalChain: TODO
    <StyledContainer variant={variant && variant.toLowerCase()} invert={invert} style={style}>
      {title}
    </StyledContainer>
  )

export default FlagComponent
